import {QuizModelType} from "@stores/quiz/QuizModel";


import {pageAdditionalParamsRef} from "../../../../volatile/pageAdditionalParams";
import {PageName, PAGES} from "@stores/ViewStore";
import {RootStoreModel} from "@stores/RootStore";


export interface OpenQuizPageParams {
    quizId: string,
    page?: PageName,
    quizMST?: QuizModelType
}

export const openQuizPage = (
    rootStore: RootStoreModel,
    {
        quizId,
        page = PAGES.QUIZ_VIEW,
        quizMST
    }: OpenQuizPageParams
) => {
    rootStore.view.openPageByName(
        page,
        {id: quizId},
        {},
        {
            quizMST: quizMST,
            back: getBackCb(rootStore, {quizId, page, quizMST}),
        }
    )
}

const getBackCb = (
    rootStore: RootStoreModel,
    {
        quizId,
        page,
        quizMST
    }: OpenQuizPageParams
) => {
    switch (page) {
        case PAGES.QUIZ_EDIT:
            return () => rootStore.view.openPageByName(
                PAGES.QUIZ_VIEW,
                {id: quizId},
                {},
                {
                    quizMST: quizMST,
                    back: () => rootStore.view.openPageByName(
                        PAGES.QUIZZES
                    )
                },
            )
        case PAGES.QUIZ_VIEW:
        default:
            const currentBackCb = pageAdditionalParamsRef.current?.back;
            return (
                currentBackCb
                    ? currentBackCb
                    : () => {
                        rootStore.view.openPageByName(
                            PAGES.QUIZZES,
                            {},
                            {},
                        )
                    }
            )
    }
}